// Vendors
import React, { createContext, PropsWithChildren, useContext, useState } from 'react';
// Types
import { StylesContextType } from './types/styles.context.type';

const StylesContext = createContext<StylesContextType>({} as StylesContextType);

const StylesContextProvider = ({ children }: PropsWithChildren): React.ReactElement => {
  const [paddingContent, setPaddingContent] = useState<boolean>(true);

  return (
    <StylesContext.Provider value={{ paddingContent, setPaddingContent }}>
      {children}
    </StylesContext.Provider>
  );
};

const useStylesContextConsumerHook = (): StylesContextType => useContext(StylesContext);

export { useStylesContextConsumerHook, StylesContextProvider };
